import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { captureException } from '@sentry/react';
import { ConfirmModal } from '@benniehealth/components-web/components/ConfirmModal';
import { useTranslation } from '@app/i18n';
import auth from '@benniehealth/core-js/store/auth';
import { stopImpersonatingUser } from '@app/api/admin';
import ImpersonationControl from '@app/components/ImpersonationControl';

export const SessionOverlays = ({
  hasNoAccess,
  isImpersonationSession,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (hasNoAccess === true && isImpersonationSession !== null) {
      setIsModalOpen(true);
    }
  }, [hasNoAccess, isImpersonationSession]);

  const modalHeaderText = isImpersonating =>
    isImpersonating
      ? t(`authentication.impersonateDeactivatedUserMessage`)
      : t(`authentication.userHasNoAccessMessage`);

  const modalButtonText = isImpersonating =>
    isImpersonating ? t(`authentication.stopSession`) : t(`authentication.logout`);

  const onModalConfirm = () => {
    if (isImpersonationSession) {
      stopImpersonatingUser().then(() => {
        navigate('/');
        window.location.reload();
      }).catch(error => {
        captureException(error, {
          tags: { section: 'SessionOverlays', action: 'stopImpersonating' },
        });
      });
      return;
    }
    setIsModalOpen(false);
    navigate('/logout');
  };

  return (
    <>
      <ImpersonationControl />
      <ConfirmModal
        isOpen={isModalOpen}
        headerMessage={modalHeaderText(isImpersonationSession)}
        confirmText={modalButtonText(isImpersonationSession)}
        onConfirm={onModalConfirm}
        cancelText=""
        onCancel={() => {}}
        hideCancelButton
      />
    </>
  );
};

SessionOverlays.propTypes = {
  hasNoAccess: PropTypes.bool,
  isImpersonationSession: PropTypes.bool,
};

const mapStateToProps = state => {
  const { isImpersonationSession } = state.companyAccesses ?? {};
  return {
    hasNoAccess: auth.selectors.noAccessSelector(state),
    isImpersonationSession: isImpersonationSession ?? null,
  };
};

export default connect(mapStateToProps)(SessionOverlays);
